module.exports = "/images/calendar-day.svg?0ac6c8f520c2b64d5f9089c3a3c5e505";